import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CanvasElement, CanvasElementType } from '@blaze-runtime/engine-domain';

import { PageLayoutBuilderService } from './page-layout-builder.service';
import { PageLayoutSerializerService } from './page-layout-serializer.service';
import {
  ComponentDescriptor,
  ComponentWorkflowsRequest,
  PageElement,
  PageLayout,
} from './page-layout.model';

@Injectable({ providedIn: 'root' })
export class LayoutOrchestratorService {
  private readonly builder = inject(PageLayoutBuilderService);
  private readonly serializer = inject(PageLayoutSerializerService);

  createPage(page: PageLayout, pageId: string, projectId: string): Observable<void> {
    return this.builder.createPage(page, pageId, projectId);
  }

  updateElement<T extends CanvasElementType>(
    pageElement: PageElement<T>,
    pageId: string,
    projectId: string,
  ): Observable<void> {
    return this.builder.updateElement(pageElement, pageId, projectId);
  }

  applyComponents(
    components: ComponentDescriptor[],
    componentWorkflows: ComponentWorkflowsRequest,
    pageId: string,
    projectId: string,
  ): Observable<void> {
    return this.builder.applyComponents(components, componentWorkflows, pageId, projectId);
  }

  getPageContent(elements: CanvasElement[], page: { id: string; name: string }): PageLayout {
    return this.serializer.getPageContent(elements, page);
  }
}
